import React from 'react';
import { Input, Button, Select, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { AdvertisingService } from 'services';
import { WhiteImage3 } from 'assets/img';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			name: '',
			url: ''
		},
		banner: '',
		image: '',
		item: this.props.item
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					url: this.props.item?.url || ''
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.image && !this.state.banner && !this.props.item) {
			Globals.showWarning("Por favor, ingrese ambas imagenes para continuar");
			return;
		}

		await AdvertisingService.admin.create({
			advertising_id: this.props.item?.id || '',
			...this.state.form,
			hasFile: true,
			// @ts-ignore
			banner: this.state.banner?.value || '',
			// @ts-ignore
			image: this.state.image?.value || '',
		});
		this.props.onClose();
		Globals.showSuccess("Se ha creado la publicidad correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-advertisement">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-6">
							<Input
								value={ this.state.form.name }
								name="name"
								placeholder="Nombre"
								label="Nombre"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.url }
								name="url"
								placeholder="URL"
								label="URL (Opcional)"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6 text-center">
							<div className="container-image banner">
								<PaperClip
									formats={['png', 'jpg', 'jpeg']}
									value={this.state.banner}
									width={1080}
									height={400}
									onChange={(e: any) => {
										this.setState({
											banner: e.target
										})
									}}>
									<div className={ `image ${ (this.state.banner || this.props.item?.banner) ? 'active' : '' }` }>
										{/*
										// @ts-ignore */}
										<img src={this.state.banner?.dataURL || (this.props.item?.banner && Constants.BASE_STORAGE + this.props.item?.banner) || WhiteImage3} />
									</div>
								</PaperClip>
								<p>Subir imagen con una resolución máxima de 1080px*400px</p>
							</div>
						</div>
						<div className="col-md-6 text-center">
							<div className="container-image">
								<PaperClip
									formats={['png', 'jpg', 'jpeg']}
									value={this.state.image}
									width={1080}
									height={1920}
									onChange={(e: any) => {
										this.setState({
											image: e.target
										})
									}}>
									<div className={ `image ${ (this.state.image || this.props.item?.image) ? 'active' : '' }` }>
										{/*
										// @ts-ignore */}
										<img src={this.state.image?.dataURL || (this.props.item?.image && Constants.BASE_STORAGE + this.props.item?.image) || WhiteImage3} />
									</div>
								</PaperClip>
								<p>Subir imagen con una resolución máxima de 1080px*1920px</p>
							</div>
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;